import SecureStorage from 'secure-web-storage';
import {CryptoSecretKey} from '../constants/enums';

const CryptoJS = require("crypto-js");

const SECRET_KEY = CryptoSecretKey;

const secureStorage = new SecureStorage(localStorage, {
    hash: function hash(key) {
        key = CryptoJS.SHA256(key, SECRET_KEY);

        return key.toString();
    },
    encrypt: function encrypt(data) {
        data = CryptoJS.AES.encrypt(data, SECRET_KEY);

        data = data.toString();

        return data;
    },
    decrypt: function decrypt(data) {
        data = CryptoJS.AES.decrypt(data, SECRET_KEY);

        data = data.toString(CryptoJS.enc.Utf8);

        return data;
    }
});

export function setItem(key,data){
    secureStorage.setItem(key, data);
}

export function getItem(key){
    return secureStorage.getItem(key);
}

export function removeItem(key){
    secureStorage.removeItem(key);
}

export function clearStorage(){
    secureStorage.clear();
}
